export default __webpack_public_path__ + "static/media/warning--curve-out-intersection-right--g1.b5a17894.png";